$(document).ready(function(){
  $(document).on("click", ".scroll--arrow", function () {
    $("html,body").animate(
      {
        scrollTop: $(".arrow_scroll_section").offset().top,
      },
      "slow"
    );
  });
  $('.has_hover_menu__wrapper').hover(
    function() {
      $('.has_hover_menu__wrapper').removeClass('active');
      $(this).addClass('active');
      $(this).find('.header__mega_menu--wrap').show();
    },
    function() {
      $(this).removeClass('active');
      $(this).find('.header__mega_menu--wrap').hide();
    }
  );

});
$('.mobile-submenu__lists').hide();
$(document).on('click', '.mobile_submenu', function(e){
  e.preventDefault();
  $(this).closest('.mobile_menu-active').toggleClass('active');
  $(this).closest('.mobile_menu-active').find('.mobile-submenu__lists').toggle();
});

$('.mobile-sub-submenu__lists').hide();
$(document).on('click', '.mob_submenu__label', function(e){
  e.preventDefault();
  $(this).closest('.mobile-menu__submenu-list-item').toggleClass('active');
  $(this).closest('.mobile-menu__submenu-list-item').find('.mobile-sub-submenu__lists ').toggle();
});


$(document).on("input", '[name="note"]', function () {
  var $el = $(this),
    $gift_c = $("#is-gift"),
    checked = $gift_c.prop("checked"),
    $cbtn = $('[name="checkout"]'),
    val = $.trim($el.val());
  if (!$gift_c.length) {
    return;
  }
  if (checked) {
    if (val.length) {
      $cbtn.prop("disabled", false);
    } else {
      $cbtn.prop("disabled", true);
    }
    $(".select_occasions").show();
  } else {
    $cbtn.prop("disabled", false);
    $(".select_occasions").hide();
    $('.select_occasions_select').val("");
  }
});

$(document).on("change", "#is-gift", function () {
  var $el = $(this),
    checked = $el.prop("checked"),
    $note = $('[name="note"]'),
    $cbtn = $('[name="checkout"]'),
    nval = $.trim($note.val());
  if (checked) {
    if (nval.length) {
      $cbtn.prop("disabled", false);
    } else {
      $cbtn.prop("disabled", true);
    }
    $(".select_occasions").show();
  } else {
    $cbtn.prop("disabled", false);
    $(".select_occasions").hide();
    $('.select_occasions_select').val("");
  }
});

